import React, { useEffect, useState } from "react";

export function FileUploadForm({ name, accept, label, documents = [] }) {
  const [hasFile, setHasFile] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [dcFile, setDcFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const doc = documents.find((d) => d.document_name === name);
    if (doc) {
      setIsUploaded(true);
      setFileUrl(doc.document_link);
    }
  }, [documents, name]);

  const uploadFile = async () => {
    if (!dcFile) return;
    setLoading(true);
    try {
      // simulate API call
      await new Promise((res) => setTimeout(res, 1000));
      setIsUploaded(true);
      setFileUrl(URL.createObjectURL(dcFile));
      setHasFile(false);
    } finally {
      setLoading(false);
    }
  };

  const cancelUploadedFile = () => {
    setIsUploaded(false);
    setDcFile(null);
    setHasFile(false);
    setFileUrl("");
  };

  const fileSelected = (e) => {
    const file = e.target.files[0];
    if (file) {
      setDcFile(file);
      setHasFile(true);
    }
  };

  return (
    <div className="file-upload-form">
      <label className="required-1">{label}</label>

      {!isUploaded && !hasFile && (
        <input type="file" name={name} accept={accept} onChange={fileSelected} />
      )}

      {isUploaded && (
        <div className="actions">
          <button type="button" className="view" onClick={() => setOpen(true)}>
            View
          </button>
          {/* <button type="button" className='edit' onClick={() => setHasFile(true)}>
            Edit
          </button> */}
          <button type="button" className="remove" onClick={cancelUploadedFile}>
            Remove
          </button>
        </div>
      )}

      {hasFile && !isUploaded && (
        <div className="actions">
          <button type="button" onClick={uploadFile} disabled={loading}>
            {loading ? "Uploading..." : "Upload"}
          </button>
          <button type="button" onClick={() => setHasFile(false)}>
            Cancel
          </button>
        </div>
      )}

      {open && (
        <div className="modal-overlay" onClick={() => setOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {fileUrl.endsWith(".pdf") ? (
              <iframe
                src={fileUrl}
                title="Document Viewer"
                style={{ width: "100%", height: "70vh", border: "none" }}
              />
            ) : (
              <img
                src={fileUrl}
                alt="Document"
                style={{ maxWidth: "100%", maxHeight: "70vh" }}
              />
            )}
            <button className="close-btn" onClick={() => setOpen(false)}>
              Close
            </button>
          </div>
        </div>
      )}

       
    </div>
  );
}
